"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const common_1 = require("../common");
const classes_1 = require("./classes");
const constants_1 = require("./constants");
class AccountService extends common_1.Service {
    constructor() {
        super();
        this.account$ = new common_1.SynchronizedSubject();
        this.accountAddress$ = this.account$.observeKey('address');
    }
    get account() {
        return this.account$.value;
    }
    get accountAddress() {
        return this.account ? this.account.address : null;
    }
    get headers() {
        return this.services.walletService.walletAddress
            ? {
                [common_1.HeaderNames.AnalyticsToken]: (0, common_1.keccak256)(this.services.walletService.walletAddress),
            }
            : {};
    }
    joinContractAccount(address) {
        this.account$.next(classes_1.Account.fromPlain({
            address,
            type: constants_1.AccountTypes.Contract,
            synchronizedAt: null,
        }));
    }
    isContractAccount() {
        return this.account.type === constants_1.AccountTypes.Contract;
    }
    onInit() {
        const { walletService, networkService } = this.services;
        this.addSubscriptions((0, rxjs_1.combineLatest)([
            walletService.walletAddress$,
            networkService.chainId$,
        ])
            .pipe((0, operators_1.map)(([address, chainId]) => !address || !chainId
            ? null
            : classes_1.Account.fromPlain({
                address,
                type: constants_1.AccountTypes.Key,
                synchronizedAt: null,
            })))
            .subscribe(this.account$));
    }
}
exports.AccountService = AccountService;
